<template>
  <router-view></router-view>
</template>

<script>
export default {

}
</script>

<style>
html {
  height: 100%;
}
body {
  min-height: 100%;
}

/* Override bootstrap-vue-next hardcoded light-theme table colors
   so that Bootswatch themes can control table text/background */
.table.b-table > tbody > tr > .table-b-table-default,
.table.b-table > tfoot > tr > .table-b-table-default,
.table.b-table > thead > tr > .table-b-table-default {
  color: var(--bs-table-color, var(--bs-body-color));
  background-color: var(--bs-table-bg, transparent);
}

/* Stored images keep a small corner by default. :where() has no specificity,
   so an app rule such as img { border-radius: 50% } replaces it. */
:where(img.view-image) {
  border-radius: 8px;
}

ul.multiselect-display {
  margin: 0;
  padding-left: 1.15em;
  text-align: left;
}

ul.multiselect-display li {
  margin: 0;
}

.multiselect-lines {
  white-space: pre-line;
}
</style>